"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = require("react");

var _ramda = require("ramda");

/**
 * Hook that allows a custom ref implementation
 * @param {string[]} path Optional property to override ref with
 * @returns {[ref, callback]} [ref, setter]
 */
var useCallbackRef = function useCallbackRef(initialValue, path) {
  if (initialValue === void 0) {
    initialValue = null;
  }

  if (path === void 0) {
    path = [];
  }

  var _useState = (0, _react.useState)(initialValue),
      ref = _useState[0],
      setRef = _useState[1];

  var callback = (0, _react.useCallback)(function (n) {
    if (n !== null) {
      setRef((0, _ramda.pathOr)(n, path, n));
    }
  }, [path]);
  return [ref, callback];
};

var _default = useCallbackRef;
exports["default"] = _default;